import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Notification from "../../../ui/Notification";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [notification, setNotification] = useState(null);

  const showNotification = (type, title, message) => {
    setNotification({ type, title, message });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      showNotification(
        "warning",
        "Missing fields",
        "Email and password are required."
      );
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE}/auth/login`, {
        email,
        password,
      });

      const { token, role } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);

      showNotification(
        "success",
        "Login successful",
        "Welcome to the admin dashboard."
      );

      setTimeout(() => {
        navigate("/dashboard", { replace: true });
      }, 800);
    } catch (err) {
      showNotification(
        "error",
        "Login failed",
        err.response?.data?.message || "Invalid email or password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#010101] px-4 relative">

      {/* NOTIFICATION (FIXED, PA CONTAINER FILE) */}
      {notification && (
        <div className="fixed top-6 right-6 z-[9999]">
          <Notification
            type={notification.type}
            title={notification.title}
            message={notification.message}
            onClose={() => setNotification(null)}
          />
        </div>
      )}

      {/* LOGIN UI */}
      <div className="w-full max-w-md bg-[#203d41] rounded-xl shadow-xl p-8">

        {/* TITLE */}
        <h1 className="text-3xl font-bold text-center text-white mb-2">
          Admin Login
        </h1>
        <p className="text-center text-gray-300 mb-8">
          Sign in to manage CMS content
        </p>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="space-y-5">

          {/* EMAIL */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded bg-[#010101] text-white border border-gray-700 focus:outline-none focus:border-[#56a5a9]"
              placeholder="admin@cms.com"
            />
          </div>

          {/* PASSWORD */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded bg-[#010101] text-white border border-gray-700 focus:outline-none focus:border-[#56a5a9]"
              placeholder="••••••••"
            />
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded bg-[#56a5a9] text-[#010101] font-semibold hover:opacity-90 transition disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        {/* FOOTER */}
        <p className="mt-6 text-center text-xs text-gray-400">
          CMS Admin Panel
        </p>
      </div>
    </div>
  );
};

export default Login;
